import React from "react";

import ProjectRadarSVG from "src/assets/svg/components/projectRadar/ProjectRadarSVG";

import styles from "./styles.module.css";

const ProjectRadarShowcase = () => {
  return (
    <div className={styles.showcaseImgWrapper}>
      <img
        src="/assets/images/project-radar-showcase.png"
        alt="project-radar-showcase"
        className={styles.showcaseImg}
      />
      <img
        src="/assets/images/project-radar-showcase-mobile.png"
        alt="project-radar-showcase"
        className={styles.showcaseImgMobile}
      />
      <div className={styles.showcaseSloganWrapper}>
        <ProjectRadarSVG fillColor={"white"} />
        <div>
          <h1 className={styles.sloganText}>
            Fiyat detaylı ve ödeme avantajlı sıfır konutlar için tek adres: Proje Radarı!
          </h1>
        </div>
      </div>
    </div>
  );
};

export default ProjectRadarShowcase;
